import * as z from "zod";

export const deleteAutomation = {
  name: "deleteAutomation" as const,
  input: z.object({ automationId: z.string() }),
  output: z.object({}),
};
